import fetch from '../../api/fetch';
import { REDUX_ACTIONS } from '../../shared/config/constants';
import { parseError } from '../../utils/fetchErrorParser';
import { enqueueSnackbar } from './snackbar';

export const getMarkeplaceTransactionList = (userEmail = null, startDate = null, endDate = null) => (dispatch) => {
  dispatch({
    type: REDUX_ACTIONS.MARKETPLACE_TRANSACTION_LIST_LOADING,
  });

  const body = { userEmail, startDate, endDate };

  const path = 'audit/marketplaceTransactionHistory';
  return fetch
    .post(path, body)
    .then((resp) => {
      if (!resp.ok) {
        return Promise.reject(resp);
      }
      return resp.json();
    })
    .then((data) => {
      dispatch({
        type: REDUX_ACTIONS.MARKETPLACE_TRANSACTION_SET_LIST,
        payload: {
          transactionHistory: data.data,
          paginatedElements: data.data.length,
        },
      });
    })
    .catch(async (error) => {
      const errorMessage = await parseError(error);

      dispatch(
        enqueueSnackbar(
          errorMessage,
          'error',
          new Date().getTime() + Math.random()
        )
      );
      dispatch({
        type: REDUX_ACTIONS.MARKETPLACE_TRANSACTION_LIST_ERROR,
        payload: { ...error, message: errorMessage },
      });
    });
};
